import { 
  Code, 
  Wrench, 
  FileText, 
  Settings2,
  Ship,
  Building2,
  MapPin,
  UserCheck,
  Calendar,
  Package,
  BarChart4,
  Brain,
  Activity,
  ClipboardList,
  HelpCircle,
  CreditCard,
  Camera,
  Bot,
  Star,
  Palette,
  Languages,
  Eye,
  BookOpen,
  Target,
  Users2,
  Clock,
  TrendingUp,
  Briefcase,
  BarChart2,
  Monitor,
  Shield,
  AlertTriangle,
  Award,
  Scale,
  Archive
} from "lucide-react";
import type { MenuItem } from "../types";

export const developmentSection: MenuItem = {
  title: "تحت التطوير",
  href: "#",
  icon: Code,
  color: "from-orange-500 to-orange-600",
  subItems: [
    // صفحات العملاء المفقودة
    {
      title: "إضافة عميل",
      href: "/clients/add",
      icon: UserCheck,
      color: "from-green-500 to-green-600",
    },
    {
      title: "عملاء B2B",
      href: "/clients/b2b",
      icon: Briefcase,
      color: "from-purple-500 to-purple-600",
    },
    {
      title: "إدارة حالة العملاء",
      href: "/client-status-management",
      icon: Settings2,
      color: "from-blue-500 to-blue-600",
    },
    {
      title: "إدارة الشركات",
      href: "/company-management",
      icon: Building2,
      color: "from-cyan-500 to-cyan-600",
    },
    {
      title: "عملاء Chatwoot",
      href: "/chatwoot-clients",
      icon: Bot,
      color: "from-pink-500 to-pink-600",
    },
    // صفحات الموظفين المفقودة
    {
      title: "ملفي الشخصي",
      href: "/my-profile",
      icon: UserCheck,
      color: "from-indigo-500 to-indigo-600",
    },
    // صفحات الإشعارات
    {
      title: "الإشعارات",
      href: "/notifications",
      icon: FileText,
      color: "from-yellow-500 to-yellow-600",
    },
    // صفحات إدارة PDF
    {
      title: "إعدادات قوالب PDF",
      href: "/pdf-template-settings",
      icon: FileText,
      color: "from-red-500 to-red-600",
    },
    // صفحات النقل البحري
    {
      title: "الموانئ",
      href: "/ports",
      icon: MapPin,
      color: "from-blue-600 to-blue-700",
    },
    {
      title: "شركات الشحن",
      href: "/shipping-companies",
      icon: Ship,
      color: "from-teal-500 to-teal-600",
    },
    // صفحات الحجوزات
    {
      title: "حجوزات الطيران",
      href: "/flight-bookings",
      icon: Calendar,
      color: "from-sky-500 to-sky-600",
    },
    {
      title: "حجوزات الفنادق",
      href: "/hotel-bookings",
      icon: Building2,
      color: "from-rose-500 to-rose-600",
    },
    // التحليلات والتقارير
    {
      title: "تحليلات الإيرادات",
      href: "/revenue-analytics",
      icon: BarChart4,
      color: "from-green-600 to-green-700",
    },
    {
      title: "تقارير المبيعات",
      href: "/sales-reports",
      icon: BarChart2,
      color: "from-purple-600 to-purple-700",
    },
    {
      title: "تحليلات الأداء الذكي",
      href: "/smart-performance",
      icon: Brain,
      color: "from-violet-500 to-violet-600",
    },
    {
      title: "تحليلات الذكاء الاصطناعي",
      href: "/ai-analytics",
      icon: Brain,
      color: "from-purple-500 to-purple-600",
    },
    // أدوات إدارية
    {
      title: "لوحة تحكم الموظف",
      href: "/employee-dashboard",
      icon: Monitor,
      color: "from-blue-500 to-blue-600",
    },
    {
      title: "إدارة الإعلانات",
      href: "/admin-announcements",
      icon: Package,
      color: "from-emerald-500 to-emerald-600",
    },
    // صفحات أمان النظام
    {
      title: "فحص صحة النظام",
      href: "/system-health",
      icon: Activity,
      color: "from-green-500 to-green-600",
    },
    {
      title: "مراقبة النظام",
      href: "/system-monitoring",
      icon: Monitor,
      color: "from-blue-500 to-blue-600",
    },
    {
      title: "قوائم المراجعة",
      href: "/checklists",
      icon: ClipboardList,
      color: "from-orange-500 to-orange-600",
    },
    // مركز الحجوزات المتقدم
    {
      title: "مركز الحجوزات",
      href: "/booking-center",
      icon: Calendar,
      color: "from-blue-500 to-blue-600",
    },
    {
      title: "إدارة قوائم الانتظار",
      href: "/waitlist-management",
      icon: Clock,
      color: "from-yellow-500 to-yellow-600",
    },
    {
      title: "طلبات التعديل",
      href: "/booking-modifications",
      icon: Settings2,
      color: "from-purple-500 to-purple-600",
    },
    {
      title: "قوالب الرسائل",
      href: "/message-templates",
      icon: FileText,
      color: "from-green-500 to-green-600",
    },
    // Quality Management and Compliance Section
    {
      title: "إدارة الشكاوى",
      href: "/complaint-management",
      icon: AlertTriangle,
      color: "from-red-500 to-red-600",
    },
    {
      title: "مراقبة جودة الخدمة",
      href: "/service-quality",
      icon: Award,
      color: "from-green-500 to-green-600",
    },
    {
      title: "الامتثال القانوني",
      href: "/legal-compliance",
      icon: Scale,
      color: "from-blue-500 to-blue-600",
    },
    {
      title: "أرشيف المستندات",
      href: "/document-archive",
      icon: Archive,
      color: "from-purple-500 to-purple-600",
    },
    {
      title: "تدقيق العمليات",
      href: "/process-audit",
      icon: Activity,
      color: "from-cyan-500 to-cyan-600",
    }
  ]
};